module.exports = __webpack_public_path__ + "img/cycle_green.cc24f969.svg";